const CENTER_DEFAULT = [55.76, 37.64];
const GET_CENTER_DURATION = 500;
const LONG_BIAS = 0.25;
const LAT_BIAS = 0.02;
const ZOOM_DEFAULT = 10;
const ZOOM_SINGLE_STORE_DEFAULT = 16;
const Z_INDEX_ACTIVE_PLACEMARK = 2001;
const Z_INDEX_ACTIVE_PLACEMARK_HOVER = 2003;
const Z_INDEX_PLACEMARK_HOVER = 2002;

export {
  CENTER_DEFAULT,
  GET_CENTER_DURATION,
  LONG_BIAS,
  LAT_BIAS,
  ZOOM_DEFAULT,
  ZOOM_SINGLE_STORE_DEFAULT,
  Z_INDEX_ACTIVE_PLACEMARK,
  Z_INDEX_ACTIVE_PLACEMARK_HOVER,
  Z_INDEX_PLACEMARK_HOVER,
};
